import { action, makeObservable } from 'mobx';
import { post } from 'stores/_services/dataService';
import BaseListStore, { BaseListStoreArgs } from 'stores/BaseListStore';
import { IDataFetchOptions } from '../../types';

export default class BaseAccessTokenListStore<T> extends BaseListStore<T> {
    constructor(listArgs: BaseListStoreArgs<T>) {
        super(listArgs);

        makeObservable(this, {
            getAccessTokens: action,
            deleteToken: action,
            createToken: action
        });
    }

    public getAccessTokens(args: IDataFetchOptions): Promise<void> {
        throw new Error('getAccessTokens is unimplemented');
    }

    public deleteToken(id: string): Promise<void> {
        throw new Error('deleteToken is unimplemented');
    }

    public async createToken(name: string): Promise<string> {
        const { data } = await post('personalAccessTokens/generate', { name });
        return data.token;
    }
}
